export default __webpack_public_path__ + "static/media/google-icon.24b4e683.svg";